<div class="settlement-detail">
    <ng-container #headerContainer></ng-container>
    <ng-container #bodyContainer></ng-container>
</div>
<footer>
    <ng-container #footerContainer></ng-container>
</footer>
